import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  EndUseConfig,
  EndUseParameterConfig
} from 'src/redux/slices/analysis/consts'
import { updateEndUseScenarioSettings } from 'src/redux/slices/analysis/reducers'
import { makeSelectEndUseSettings } from 'src/redux/slices/analysis/selectors'
import {
  FuelSourceKeys,
  UpdateEndUseScenarioSettingsPayload
} from 'src/redux/slices/analysis/types'
import {
  SelectOnChangHandler,
  TextFieldOnChangeEvent
} from 'src/types/event-handlers'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'

// TODO: abstract to be agnostic as to settings subtable (endUses, fuels)

type ScenarioEndUseParameterProps = Omit<UpdateEndUseScenarioSettingsPayload['payload'], 'value'>

const ScenarioEndUseParameter: React.FC<ScenarioEndUseParameterProps> = ({
  scenarioName,
  endUse,
  parameter,
}) => {
  const value = useSelector(makeSelectEndUseSettings(scenarioName, endUse, parameter))
  const dispatch = useDispatch()
  const parameterConfig = useMemo(() => EndUseParameterConfig[parameter], [parameter])
  const endUseConfig = useMemo(() => EndUseConfig[endUse], [endUse])

  const handleChange = useCallback(
    (e: TextFieldOnChangeEvent) => {
      dispatch(
        updateEndUseScenarioSettings({
          scenarioName,
          endUse,
          parameter,
          value:
            parameterConfig.type === 'number'
              ? Number(e.target.value)
              : (e.target.value as FuelSourceKeys),
        }),
      )
    },
    [dispatch, updateEndUseScenarioSettings, parameterConfig],
  )

  if (parameterConfig.type === 'number' && parameterConfig.numberConfig)
    return (
      <TextField
        label={`${endUseConfig.label} ${parameterConfig.label}`}
        fullWidth
        // variant="outlined"
        type='number'
        InputProps={{
          inputProps: {
            min: parameterConfig.numberConfig.min,
            max: parameterConfig.numberConfig.max,
            step: parameterConfig.numberConfig.step,
          },
        }}
        value={value}
        // helperText={parameterConfig.units}
        onChange={handleChange}
      />
    )
  if (parameterConfig.type === 'select' && parameterConfig.options)
    return (
      <FormControl fullWidth>
        <InputLabel id={`${scenarioName}-${endUse}-${parameter}-label`}>
          {endUseConfig.label} {parameterConfig.label}
        </InputLabel>

        <Select
          labelId={`${scenarioName}-${endUse}-${parameter}-label`}
          id={`${scenarioName}-${endUse}-${parameter}`}
          value={value}
          onChange={handleChange as SelectOnChangHandler}
        >
          {parameterConfig.options.map(({ value, label }) => (
            <MenuItem value={value} key={`${scenarioName}-${endUse}-${parameter}-option-${value}`}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  return <>Unimplemented control type.</>
}

export default ScenarioEndUseParameter
